
import {Component, Prop, Vue} from "vue-property-decorator";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {auditTrailModule, currentUserModule, studyPatientModule, visitModule} from "@/store";
import {translate} from "@/auxillary/translation";
import {formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {AuditTrailTable}
})
export default class VisitAuditTrailView extends Vue {
  @Prop({default: ""}) private patientId: string;
  @Prop({default: ""}) private visitId: string;

  get studyPatientAlias() {
    return studyPatientModule.studyPatient?.displayName ?? "";
  }

  get visitDisplayName() {
    return translate(visitModule?.visit?.displayKey ?? "");
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    await visitModule.loadById(this.visitId);
    await auditTrailModule.loadForVisit(this.visitId)
  }

  async back() {
    await this.$router.push({
      name: "patient",
      params: {patientId: this.patientId}
    }).catch();
  }
}
